import React from 'react';
import Avatar from './Avatar';

function Banner({ avatar, banner, avatarRawSrc, bannerRawSrc, username, children }) {
    const bannerUrl = `${process.env.REACT_APP_API_STORAGE}`;
    const bannerSrc = bannerRawSrc ? banner : (banner ? `${bannerUrl}/${banner}` : null);

    return (
        <div
            className="relative h-40 bg-blue-strong"
            style={bannerSrc ? {
                backgroundImage: `url(${bannerSrc})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            } : {}}
        >
            <div className="avatar-container border-4 w-36 h-36 absolute left-4 bottom-0 transform translate-y-1/3 rounded-full overflow-hidden bg-gray-mid z-30">
                <Avatar useRawSrc={avatarRawSrc} src={avatar} alt={username} className="w-full h-full object-cover !border-0" />
                {children && <>{children}</>}
            </div>
        </div>
    );
}

export default Banner;
